var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "swipe_magic_nav_inner" }, [
    _c(
      "div",
      { staticClass: "content" },
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "img-box" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: { src: item.imageurl },
            }),
            item.title
              ? _c(
                  "div",
                  {
                    staticClass: "title",
                    style: { color: item.title_color || "#333333" },
                  },
                  [_vm._v(" " + _vm._s(item.title) + " ")]
                )
              : _vm._e(),
            item.btn_text
              ? _c(
                  "div",
                  {
                    staticClass: "btn",
                    style: { color: item.btn_color || "#b37b3d" },
                  },
                  [
                    _c("span", [_vm._v(" " + _vm._s(item.btn_text) + " ")]),
                    _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }